import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import HttpManager from "../../../services/HttpManager";
import { ProspectCatalogs } from "../../../services/v2/prospects.service";
import { cuando, errorTexto } from "./salesHelpers";

interface Props { campusId: number; catalogs: ProspectCatalogs | null; onClose: () => void; }

const EQUIPOS = [{ k: "ventas", n: "Ventas" }, { k: "admisiones", n: "Admisiones" }, { k: "caja", n: "Caja" }, { k: "otro", n: "Otro" }];
const PAIS: { [k: number]: string } = { 1: "México", 2: "Honduras", 60: "El Salvador" };

/**
 * Números de WhatsApp (supervisión): de qué plantel y equipo es cada uno. Con eso WAPP sabe desde qué número
 * contestarle a quien nunca escribió y a qué bandeja cae lo que entra. Se guarda al cambiar cada campo.
 */
const NumerosModal: React.FC<Props> = ({ campusId, catalogs, onClose }) => {
	const http = HttpManager.getInstance();
	const [rows, setRows] = useState<any[] | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [guardado, setGuardado] = useState<number | null>(null);
	// Desde 2026-10-06 los números se manejan en Mensajería → Números (solo superadmin); aquí queda la rotación.
	const [pestana, setPestana] = useState<"numeros" | "rotacion">("rotacion");
	const [rot, setRot] = useState<any | null>(null);

	useEffect(() => {
		http.prospectsService.rotation(campusId).then((r) => setRot(r.data)).catch(() => setRot(null));
	}, [campusId]);

	const cambiarRotacion = async (id: string, dentro: boolean) => {
		setError(null);
		try { setRot((await http.prospectsService.setInRotation(campusId, id, dentro)).data); } catch (e) { setError(errorTexto(e)); }
	};

	const guardar = async (id: number, data: any) => {
		setError(null);
		try {
			const r = await http.prospectsService.updateWaChannel(campusId, id, data);
			setRows((r.data as any).channels);
			setGuardado(id); setTimeout(() => setGuardado(null), 1200);
		} catch (e) { setError(errorTexto(e)); }
	};

	return (
		<Modal show onHide={onClose} size="xl" className="ventas-nuevo-modal">
			<Modal.Header closeButton><Modal.Title style={{ fontFamily: "Bricolage, sans-serif", fontWeight: 800 }}>Rotación de asesoras</Modal.Title></Modal.Header>
			<Modal.Body>
				<div className="aviso" style={{ marginBottom: 12 }}>Los números de WhatsApp (plantel, equipo, perfil, estado) ahora están en Mensajería → Números.</div>
				{error ? <div className="aviso error">{error}</div> : null}
				{pestana === "rotacion" ? (
					!rot ? <div className="ventas-vacio">Cargando…</div> : (
						<div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
							<div className="aviso">{rot.autoassign ? "WAPP está repartiendo a quien escribe por primera vez." : "Apagado: por ahora reparte el router en Zoho. Aquí se deja lista la lista de cada ruta para cuando WAPP reparta."}</div>
							{rot.routes.map((r: any) => (
								<div key={r.code} className="tarjeta">
									<div className="tarjeta-cab"><h4>{r.name}</h4><span className="apagado">{r.channels.join(" · ") || "sin números"}</span></div>
									<div className="nm-asesoras">
										{r.advisors.map((a: any) => (
											<label key={a.id} className={"nm-asesora" + (a.inRotation ? "" : " fuera")}>
												<input type="checkbox" checked={!!a.inRotation} onChange={(e) => cambiarRotacion(a.id, e.target.checked)} />
												<span>{a.name}<br /><span className="apagado">{a.role}</span></span>
											</label>
										))}
										{!r.advisors.length ? <span className="apagado">Nadie activo con esos roles.</span> : null}
									</div>
								</div>
							))}
						</div>
					)
				) : null}
				{pestana === "numeros" ? <p className="apagado" style={{ marginTop: 0 }}>De qué plantel y equipo es cada número y por qué ruta reparte. Los "pendientes" de Meta vienen apagados: son copias a medio migrar.</p> : null}
				{pestana !== "numeros" ? null : !rows ? <div className="ventas-vacio">Cargando…</div> : (
					<div className="nm-tabla" role="table">
						<div className="nm-fila cab" role="row">
							<span>Número</span><span>Nombre para el equipo</span><span>Plantel</span><span>Equipo</span><span>Reparte a</span><span>Mensajes</span><span>Activo</span>
						</div>
						{rows.map((c) => (
							<div key={c.id} className={"nm-fila" + (c.bool_enabled ? "" : " apagada")} role="row">
								<span><b>{c.display_phone}</b><br /><span className="apagado">{c.name} · {PAIS[c.country_id] || ""}</span></span>
								<span><input defaultValue={c.label || ""} aria-label={"Nombre de " + c.display_phone} onBlur={(e) => e.target.value !== (c.label || "") && guardar(c.id, { label: e.target.value })} /></span>
								<span>
									<select value={c.campus_id || ""} aria-label={"Plantel de " + c.display_phone} onChange={(e) => guardar(c.id, { campusId: e.target.value ? Number(e.target.value) : null })}>
										<option value="">— todo el país —</option>
										{(catalogs?.campuses || []).map((p) => <option key={p.id} value={p.id}>{p.name.replace("Washington Academy ", "")}</option>)}
									</select>
								</span>
								<span>
									<select value={c.dept} aria-label={"Equipo de " + c.display_phone} onChange={(e) => guardar(c.id, { dept: e.target.value })}>
										{EQUIPOS.map((x) => <option key={x.k} value={x.k}>{x.n}</option>)}
									</select>
								</span>
								<span>
									<select value={c.route || ""} aria-label={"Ruta de " + c.display_phone} onChange={(e) => guardar(c.id, { route: e.target.value || null })}>
										<option value="">— no reparte —</option>
										{(rot?.routes || []).map((r: any) => <option key={r.code} value={r.code}>{r.name}</option>)}
									</select>
								</span>
								<span className="apagado">{c.mensajes ? Number(c.mensajes).toLocaleString("es-MX") + " · " + cuando(c.ultimo) : "—"}</span>
								<span><input type="checkbox" checked={!!c.bool_enabled} aria-label={"Activo " + c.display_phone} onChange={(e) => guardar(c.id, { enabled: e.target.checked })} />{guardado === c.id ? <span className="nm-ok"> ✓</span> : null}</span>
							</div>
						))}
					</div>
				)}
			</Modal.Body>
			<Modal.Footer><button className="btn-wa" onClick={onClose}>Cerrar</button></Modal.Footer>
		</Modal>
	);
};

export default NumerosModal;
